import { toastSuccess } from "./toast";

export const copyToClipboard = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, copyText: string) => {
  navigator.clipboard.writeText(copyText);
  toastSuccess('Successfully copied to clipboard.');
};
